..
<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                          :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="uid" label="用户UID" prop="uid">
                    <span class="form_span">{{ domainData.uid }}</span>
                </a-form-model-item>

                <a-form-model-item ref="name" label="用户名称" prop="name">
                    <a-input v-model="domainData.name" @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>

                <a-form-model-item ref="status" label="用户状态" prop="userstate">
                    <a-radio-group v-model="domainData.status" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="0"> 普通用户</a-radio-button>
                        <a-radio-button value="1"> 开发者</a-radio-button>
                        <a-radio-button value="2"> 付费开发者</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="idcardno" label="身份证号" prop="name">
                    <a-input v-model="domainData.idcardno" @blur="
                        () => {
                            $refs.idcardno.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>
                <a-form-model-item ref="idcardimg" label="身份证照片" prop="name">
                    <a-input v-model="domainData.idcardimg" @blur="
                        () => {
                            $refs.idcardimg.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>
                <a-form-model-item label="身份证照片">
                    <img :src="C.OSS_LOCATION + domainData.idcardimg" style="width:300px;max-height:220px;" alt="">
                </a-form-model-item>
                <a-form-model-item ref="idcardimg" label="其它照片" prop="name">
                    <a-input v-model="domainData.otherimg" @blur="
                        () => {
                            $refs.otherimg.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>
                <a-form-model-item ref="expires" label="到期日期" prop="name">
                    <a-input v-model="domainData.expires" @blur="
                        () => {
                            $refs.otherimg.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>
                <a-form-model-item ref="apinum" label="剩余调用次数" prop="name">
                    <a-input v-model="domainData.apinum" @blur="
                        () => {
                            $refs.apinum.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    'edituser': '编辑用户'
};
export default {
    data() {
        return {
            m_title,
            c_title: '',
            labelCol: {span: 6},
            wrapperCol: {span: 8},
            rules: {
                status: [
                    {required: true, message: '请选择用户类型', trigger: 'blur'},
                ]
            },
            confirmLoading: false,
            tLoading: false,
            formItemLayout: 'horizontal',
            domainData: {},
            selecterState: {
                isShow: false,
                rowsType: 'radio' // or 'checkbox'，单选或多选
            },
            is_vue_task: true,
        };
    },
    components: {},

    methods: {
        handleOk() {
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    console.log(that.domainData);
                    // const {params} = this.$route;
                    //编辑
                    this.$store
                        .dispatch({
                            type: "open/updateOpenUserinfo",
                            params: that.domainData
                        })
                        .then((response) => {
                            if (response.data.success == '1') {
                                console.log(response)
                                that.handleCancel()
                                that.confirmLoading = false;
                            }
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {
        const {query, params} = this.$route;
        this.c_title = m_title[params.action];
        let that = this;
        if (params.action != "adduser") {
            that.$store.dispatch({
                type: "open/selectOpenUserinfosOne",
                params: query
            }).then((res) => {
                console.log(res);
                that.tLoading = false;
                that.domainData = res.data.data
            })
        }

    }
};
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
